import styled from "styled-components";

export const Container = styled.div<{
	scale: number;
	left: number;
	top: number;
}>`
	width: 331px;
	position: fixed;
	top: ${(props) => props.top}px;
	left: ${(props) => props.left}px;
	transform: scale(${(props) => props?.scale});
	transform-origin: center left;
`;

export const ArrowContainer = styled.div`
	margin-left: 100px;
`;

export const SlideNumberContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 4px;
	margin-right: 10px;
`;
